import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import React from 'react';

export default function withRouter(Child) {
    return (props) => {
        const location = useLocation();

        const navigate = useNavigate();

        const params = useParams();

        const [searchParams, setSearchParams] = useSearchParams();
        const linkTo = (path) => {
            navigate(path);
        };

        return (
            <Child {...props} searchParams={searchParams} setSearchParams={setSearchParams} navigate={linkTo} location={location} params={params} />
        );
    };
}
